import React from 'react';
import { DepartmentsSelectSearchControl } from 'src/components/common/DepartmentsSelectSearchControl/DepartmentsSelectSearchControl';
import { useEmployeeFormContext } from 'src/components/enterprise/features/Employee/components/Form/EmployeeFormProvider/useEmployeeFormContext';

export function DepartmentsSelectSearchControlWrapper(): JSX.Element {
  const { corpData } = useEmployeeFormContext();

  return (
    <DepartmentsSelectSearchControl
      id="departmentId"
      name="departmentId"
      rules={{
        ...(corpData.departmentsRequired && {
          required: 'Department is required',
        }),
      }}
    />
  );
}
